import React from 'react';
import WebApi from './WebApi';



export class NegotiationService {
  static async save(negotiation, token, newClient, loggedUser, userName) {

    let params = {
      OrigemVenda:negotiation.salesOrigin.id,
      SalvarSharePoint: negotiation.saveSharepoint,
      Justificativa: negotiation.justification,
      NomeUsuario: userName,
      Veiculo: negotiation.mainVehicle.id,
      ClienteNovo: newClient,
      Login: token.profile.sub,
      DataInicio: negotiation.beginDate,
      DataFim: negotiation.endDate,
      PlanoComercial:
        negotiation.commercialPlan && negotiation.commercialPlan._id
          ? {
              Id: negotiation.commercialPlan._id,
              Nome: negotiation.commercialPlan.title
            }
          : null,
      Agencias: negotiation.agency.map(ag => { return {
        Id: ag.id,
        Nome: ag.nome,
        Cnpj: ag.cnpj || ag.cpf
      }}),
      Cliente: {
        Id: negotiation.client.id,
        Nome: negotiation.client.nome || negotiation.client.razaoSocial,
        Cnpj: negotiation.client.cnpj || negotiation.client.cpf
      },
      Executivo: {
        IdExecutivo: negotiation.executive.idExecutivo,
        NomeExecutivo: negotiation.executive.nomeExecutivo,
        EmailNegociacao: negotiation.executive.emailNegociacao
      },
      TipoVenda: {
        Id: negotiation.salesType.id,
        Nome: negotiation.salesType.nome
      },


      Natureza: {
        Id: negotiation.nature.id,
        Nome: negotiation.nature.nome
      },
      TabelaPreco: {
        Id: negotiation.table.id,
        Nome: negotiation.table.nome
      },
      TipoFaturamento: {
        Id: negotiation.paymentType.id,
        Nome: negotiation.paymentType.nome
      },
      Pracas: negotiation.comprehensiveness,
      Reaplicacao: negotiation.withreplication,
      OutrosVeiculos: negotiation.withOthersVehicles,
      Digital: negotiation.withDigital,
      Valor: negotiation.totalAmount,
      PercentualDesconto: negotiation.discount || 0
    };

    if (
      (negotiation.withOthersVehicles || negotiation.withDigital) &&
      negotiation.apportionments &&
      negotiation.apportionments.length > 0
    ) {
      let apportionments = [];
      negotiation.apportionments.forEach((a, i) => {
        apportionments[i] = {
          IdVeiculo: a.vehicle.id,
          NomeVeiculo: a.vehicle.nome,
          Valor: a.amount,
          Porcentagem: a.percent,
          Tipo: a.type
        };
      });
      params = { ...params, Rateios: apportionments };
    }
    const response = await WebApi.post('/negociacoes', params);
    if(params.SalvarSharePoint === 'S'){
      //let link = window.location.href = ('https://band.sharepoint.com/sites/fiquepordentro', '_blank'); 
      let link = window.open('https://band.sharepoint.com/sites/fiquepordentro', '_blank'); 
      return link;
     }else{
      return response.data;
      
     }
  }

  static async search(
    executive,
    registerPerPage,
    search = '',
    column = '',
    direction = ''
  ) {
    const response = await WebApi.get('/negociacoes', {
      RegistrosPorPagina: registerPerPage,
      OrdenacaoCampo: column,
      OrdenacaoSentido: direction,
      Busca: search,
      IdsExecutivos: executive.identificacao
        ? executive.identificacao.map(i => i.idExecutivo)
        : [0]
    });
    return response.data;
  }

  static async get(id) {
    const response = await WebApi.get(`/negociacoes/${id}`);
    return response.data;
  }
}
